import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { useAuth } from '../../../../../context/AuthContext';
import Swal from 'sweetalert2'


export const AdminPackageandPrice = () => {
    const { user } = useAuth();
    const [msg, setMsg] = useState([]);
    const { t } = useTranslation()

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const headerss = {
                "accept": "*/*",
                'Content-Type': 'application/json',
                'Access-Control-Allow-Credentials': 'false',
                'Authorization': 'Bearer ' + user.token

            }
            let url = "https://api.heryerdeingilizce.com/api/admin/Package/Create";
            await axios({
                method: 'Post',
                url: url,
                data: {
                    packageName: document.getElementById("packageName").value,
                    packageDetail: document.getElementById("packageDetail").value,
                    packagePrice: document.getElementById("packagePrice").value,
                    studentLimit: document.getElementById("studentLimit").value,
                    howManyDays: document.getElementById("howManyDays").value,
                    sortNumber: document.getElementById("sortNumber").value,
                    isItPrivate: document.getElementById("isItPrivate").value,
                    isInvidual: document.getElementById("isInvidual").value,
                    isActive: true
                },
                headers: headerss
            }).then(res => {
                if (res.status === 200) {
                    if (res.data['success']) {
                        Swal.fire({
                            title: "Başırılı!",
                            icon: "success",
                            confirmButtonText: `Tamam`
                        });
                        window.location.reload();

                    }
                    else {
                        Swal.fire({
                            title: "error!",
                            icon: "error",
                            confirmButtonText: `Tamam`
                        });
                        setMsg(res.data['message']);
                    }
                }
                else {
                    Swal.fire({
                        title: "hata!",
                        icon: "error",
                        confirmButtonText: `Tamam`
                    });
                    setMsg("Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.");
                }
            });
        } catch (err) {
            setMsg(err);
        }
    }

    return (
        <div style={{ backgroundColor: "white", padding: "3%" }}>
            <div style={{ textAlign: "center" }}>
                <h1>{t("packagesAndPrices")}</h1>
            </div>
            <h4>{msg}</h4>
            <form onSubmit={handleSubmit} >
                <h4>{t("createPackage")}</h4>

                <div className="mb-3">
                    <label htmlFor="packageName" className="form-label">{t("packageName")}</label>
                    <textarea className="form-control" id="packageName" required />
                </div>
                <div className="mb-3">
                    <label htmlFor="packageDetail" className="form-label">{t("packageDescription")}</label>
                    <textarea className="form-control" id="packageDetail" required />
                </div>
                <div className="mb-3">
                    <label htmlFor="packagePrice" className="form-label">{t("packagePrice")}</label> <br />
                    <i>{t('useNumbers')}</i>
                    <textarea className="form-control" id="packagePrice" required />
                </div>

                <div className="mb-3">
                    <label htmlFor="studentLimit" className="form-label">{t("studentLimit")}</label><br />
                    <i>{t('useNumbers')}</i>
                    <textarea className="form-control" id="studentLimit" required />
                </div>

                <div className="mb-3">
                    <label htmlFor="howManyDays" className="form-label">{t("validityDate")}</label><br />
                    <i>{t('useNumbers')}</i><i>{t('daily')}</i>
                    <textarea className="form-control" id="howManyDays" required />
                </div>
                <div className="mb-3">
                    <label htmlFor="isInvidual" className="form-label">{t('isInvidual')}</label>
                    <select id="isInvidual" className="form-select" required >
                        <option key="1" value="test">{t('select')}</option>
                        <option key="1" value="true">{t('yes')}</option>
                        <option key="0" value="false">{t('no')}</option>
                    </select>
                </div>
                <div className="mb-3">
                    <label htmlFor="isItPrivate" className="form-label">{t('isItPrivate')}</label>
                    <select id="isItPrivate" className="form-select" required >
                        <option key="1" value="test">{t('select')}</option>
                        <option key="1" value="true">{t('yes')}</option>
                        <option key="0" value="false">{t('no')}</option>
                    </select>
                </div>
                <div className="mb-3">
                    <label htmlFor="sortNumber" className="form-label">{t("sortid")}</label>
                    <textarea className="form-control" id="sortNumber" required />
                </div>
                <div className='d-flex justify-content-center'>
                    <button type="submit" className="btn btn-primary btn-lg">{t("create")}</button>
                </div>

            </form>
        </div>
    )
}
export default AdminPackageandPrice;